import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from '@openng/optimus-ui/button';
import { HeaderService } from '../header.service';

/**
 * Right-aligned header CTAs. Both the persona switch ("I'm a Renter" /
 * "I'm a Landlord") and "Post Your Pad" only render on marketing pages
 * (those pages opt in by publishing header menu items + an alt landing
 * link). On app pages — dashboard etc. — nothing is rendered.
 *
 * The persona switch replaces the older inline Rent↔Lease swap, so users
 * can flip between the two landing pages without losing their place in
 * the middle nav.
 */
@Component({
  selector: 'padspin-header-extra-buttons',
  // `display: contents` so we don't introduce a new flex item — the parent
  // (`<padspin-header />`) already lays its children out with `gap-2`, and
  // we want a *larger* gap only between the persona switch and the gradient
  // CTA. The inner div owns that spacing.
  styles: `
    :host {
      display: contents;
    }
  `,
  template: `
    @if (isMarketingPage()) {
      <div class="flex flex-row items-center gap-4 sm:gap-5">
        @if (altLink(); as alt) {
          <a
            [routerLink]="alt.routerLink"
            class="hidden text-sm font-medium text-color transition-colors hover:text-muted-color sm:inline-flex"
            >{{ alt.label }}</a
          >
        }
        <a pButton size="small" routerLink="/post-pad">Post Pad</a>
      </div>
    }
  `,
  imports: [RouterLink, ButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderExtraButtonsComponent {
  private readonly header = inject(HeaderService);
  private readonly pageMenuItems = this.header.getMenuItems();
  protected readonly altLink = this.header.getAltLandingLink();
  protected readonly isMarketingPage = computed(
    () => this.pageMenuItems().length > 0,
  );
}
